
import React from 'react';
import './HealthTwoFeaturedBrand.scss';
import { useCollection } from '../../../../firebase-files/hooks/useCollection';

const HealthTwoFeaturedBrand = () => {
  const { documents } = useCollection("media", ["category", "==", "partners"]);

  const featuredBrands = documents
    ? documents
        .filter(brand => brand.status === "active")
        .slice(0, 7)
    : [];

  return (
    <section className="health-two-featured-brands">
      <div className="header">
        <h2 className="health-two-section-heading">Our Partners</h2>
        <button className="see-all">
          SEE ALL PARTNERS <span className="arrow">→</span>
        </button>
      </div>

      <div className="brands-list">
        {featuredBrands.map((brand, index) => (
          <a
            key={index}
            className="brand-card"
            href={`/${brand.pageName || "#"}`} 
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={brand.mediaUrl} alt={`Partner ${index + 1}`} />
          </a>
        ))}
      </div>
    </section>
  );
};

export default HealthTwoFeaturedBrand;
